export default function closeAllModals () {
  return {
    type: 'CLOSE_ALL_MODALS',
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-router/actions/closeAllModals.js